var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.032 28H23.816C23.592 28 23.412 27.944 23.276 27.832C23.148 27.72 23.044 27.592 22.964 27.448L18.944 20.788C18.88 20.988 18.804 21.16 18.716 21.304L14.864 27.448C14.768 27.584 14.656 27.712 14.528 27.832C14.408 27.944 14.248 28 14.048 28H11.036L16.796 19.072L11.264 10.648H14.48C14.704 10.648 14.864 10.68 14.96 10.744C15.064 10.8 15.16 10.896 15.248 11.032L19.196 17.392C19.276 17.192 19.372 16.992 19.484 16.792L23.108 11.092C23.196 10.94 23.292 10.828 23.396 10.756C23.5 10.684 23.632 10.648 23.792 10.648H26.876L21.296 18.94L27.032 28Z",
    fill: "#A0A0A0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 17.5,
    stroke: "#BEBEBE",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.5601614cccd037e99842379db65efc6f.svg";
export { ForwardRef as ReactComponent };